import { useEffect, useState } from "react";
import BreadCrumb from "../../../../components/breadcrumb";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";
import { TeamData } from "../../../../components/tables/team-tables/team";
import { getAllTeam } from "../../../../API/Team/teamService";

const breadcrumbItems = [
  { title: "Équipe", link: "/admin-dashboard/organigramme-equipe" },
];
export default function Team() {
  const [teams, setTeams] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllTeam();

    setTeams(response?.teams);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <TeamData data={teams} />
        </div>
      </div>
    </>
  );
}
